import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { Roles } from './core/models/roles';


const routes: Routes = [
  { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
  { path: 'main', loadChildren: () => import('./main/main.module').then(m => m.MainModule),
    canActivate: [AuthGuard],
  },
  { path: 'tutorial', loadChildren: () => import('./tutoriales/tutoriales.module').then(m => m.TutorialesModule),
    canActivate: [AuthGuard]
  },
  { path: 'pedidos', loadChildren: () => import('./pedidos/pedidos.module').then(m => m.PedidosModule),
    canActivate: [AuthGuard],
    data:{
      rolesUsuario: [Roles.VERPEDIDOS]
    }
  },
  { path: 'facturacion', loadChildren: () => import('./facturacion/facturacion.module').then(m => m.FacturacionModule),
  canActivate: [AuthGuard],
  data:{
    rolesUsuario: [Roles.VERFACTURACIONYPAGO]
  }
  },
  { path: 'admin-usuarios', loadChildren: () => import('./administrador-usuarios/administrador-usuarios.module').then(m => m.AdministradorUsuariosModule),
    canActivate: [AuthGuard],
    data:{
      rolesUsuario: [Roles.VERADMINISTRACIONDEUSUARIO]
    }
  },
  { path: 'admin-perfiles', loadChildren: () => import('./administrador-perfiles/administrador-perfiles.module').then(m => m.AdministradorPerfilesModule),
    canActivate: [AuthGuard],
    data:{
      rolesUsuario: [Roles.VERADMINISTRACIONDEPERFIL]
    }
  },
  { path: 'ejecutivo', loadChildren: () => import('./ejecutivo/ejecutivo.module').then(m => m.EjecutivoModule),
    canActivate: [AuthGuard]
  },
  { path: '', redirectTo: 'auth', pathMatch: 'full'},
  { path: '**', redirectTo: 'auth', pathMatch: 'full'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
